export const FOR_COMPANIES_PLUSES_LIST = [{
  header: 'Customized Training Programs',
  text: 'We&nbsp;tailor our courses to&nbsp;meet the specific needs of&nbsp;your team. Do&nbsp;you need a&nbsp;greater focus on&nbsp;negotiation skills? Or&nbsp;perhaps more emphasis on&nbsp;written communication? We&nbsp;consider the unique aspects of&nbsp;your work to&nbsp;create the best fit.'
}, {
  header: 'Flexible Class Format',
  text: 'Our online lessons are scheduled at&nbsp;times that work best for your employees, ensuring that their learning fits seamlessly into their workday.'
}, {
  header: 'Experienced Teachers',
  text: 'Our expert teachers, who have international experience, will help your team master English in&nbsp;ways that are directly applicable to&nbsp;real business challenges.'
}, {
  header: 'Progress Reports',
  text: 'We&nbsp;provide regular assessments of&nbsp;each employee&rsquo;s progress along with recommendations for further learning.'
}, {
  header: 'Enhanced Work Efficiency',
  text: 'With strong English skills, your team will be&nbsp;able to&nbsp;negotiate, solve problems, and engage with international clients without any language barriers.'
}];